// extracted by mini-css-extract-plugin
module.exports = {"planCard":"planCard_planCard__3Y6Kh","top":"planCard_top__1Gu45","diffBg":"planCard_diffBg__2MMgN","body":"planCard_body__1bjY0","bottom":"planCard_bottom__3wxRQ"};